// Getters
export const pages = (state) => {
  return state.pages.data || []
}
export const pagesLoading = (state) => {
  return state.pages.loading
}
export const pagesLastUpdate = (state) => {
  return state.pages.lastUpdate
}

export const pageContent = (state) => (id) => {
  return (state.pageContent.data || {})[id] || []
}
export const pageContentLoading = (state) => (id) => {
  return (state.pageContent.loading || {})[id] || false
}
export const pageContentLastUpdate = (state) => (id) => {
  return (state.pageContent.lastUpdate || {})[id] || null
}

export const filters = (state) => {
  return state.filters.data || []
}
export const filtersFormatted = (state) => {
  return (state.filters.data || []).map((filter) => {
    return {
      key: filter.options.key,
      value: filter.data || filter.options.default,
      operation: filter.options.operation,
    }
  })
}
export const analysisBi = (state) => {
  return state.analysisBi.data || []
}
export const analysisBiLoading = (state) => {
  return state.analysisBi.loading
}
export const analysisBiLastUpdate = (state) => {
  return state.analysisBi.lastUpdate
}

export const modeloServirOverview = (state) => {
  return state.modeloServirOverview.data || []
}
export const modeloServirOverviewLoading = (state) => {
  return state.modeloServirOverview.loading
}
export const modeloServirOverviewLastUpdate = (state) => {
  return state.modeloServirOverview.lastUpdate
}

export const modeloServirProductivity = (state) => {
  return state.modeloServirProductivity.data || []
}
export const modeloServirProductivityLoading = (state) => {
  return state.modeloServirProductivity.loading
}
export const modeloServirProductivityLastUpdate = (state) => {
  return state.modeloServirProductivity.lastUpdate
}

export const modeloServirIndividual = (state) => {
  return state.modeloServirIndividual.data || []
}
export const modeloServirIndividualLoading = (state) => {
  return state.modeloServirIndividual.loading
}
export const modeloServirIndividualLastUpdate = (state) => {
  return state.modeloServirIndividual.lastUpdate
}

export const filtroModeloServir = (state) => {
  return state.filtroModeloServir || {}
}
